import { apiClient, clean } from "./apiClient";
import type { PageRequest, PageResponse } from "@/types/api";
import type { PropertyMediaAssetEntity } from "@/types/property";

export interface MediaAssetFilter {
  propertyId?: string;
  externalPropertyId?: string;
  legalEntityId?: string;
  branchId?: string;
}

export const mediaAssetsService = {
  list(
    filter: MediaAssetFilter,
    page: PageRequest,
  ): Promise<PageResponse<PropertyMediaAssetEntity>> {
    return apiClient
      .get<PageResponse<PropertyMediaAssetEntity>>("/media-assets", {
        params: { ...clean(filter), ...clean(page) },
      })
      .then((r) => r.data);
  },

  /**
   * Fetches asset counts for all given property IDs in a single API call.
   * Returns a map of propertyId → count. Properties with zero assets are omitted.
   * Falls back to an empty map on error so callers can gracefully degrade.
   */
  batchCounts(propertyIds: string[]): Promise<Record<string, number>> {
    if (propertyIds.length === 0) return Promise.resolve({});
    return apiClient
      .get<Record<string, number>>("/media-assets/counts", {
        params: { propertyIds: propertyIds.join(",") },
      })
      .then((r) => r.data)
      .catch(() => ({}));
  },
};

